import { DateTime } from "luxon"
import { StrictOmit } from "../../../../lib/lang"
import { MonetaryAmount } from "../../../currency/currencyTypes"
import { History } from "../../../users/userTypes"
import { PriceListType } from "../priceList/priceListApi"

export enum WeekDays {
    MONDAY = "MONDAY",
    TUESDAY = "TUESDAY",
    WEDNESDAY = "WEDNESDAY",
    THURSDAY = "THURSDAY",
    FRIDAY = "FRIDAY",
    SATURDAY = "SATURDAY",
    SUNDAY = "SUNDAY",
}

export type WeekDaysType = keyof typeof WeekDays

export type ProductGroupItem = Readonly<{
    id: number
    productGroupCode?: ProductGroupCode
    name: string
    isActive: boolean
    availabilityDetails?: {
        weekDays: string[]
        timeInterval: {
            start: string
            end: string
        }
    }
    securitySettings?: {
        isLocked: boolean
    }
}>

export type ProductGroupCode = {
    id: number
    number: string
    name: string
    description?: string
    isActive?: boolean
}

export type ProductGroupPriceList = Readonly<{
    id: number
    name: string
    adjustedPrice?: MonetaryAmount
}>

export type ProductGroup = Readonly<{
    id: number
    name: string
    isActive?: boolean
    productGroupCode?: ProductGroupCode
    priceLists?: ProductGroupPriceList[]
    availabilityDetails?: {
        weekDays: WeekDaysType[]
        timeInterval: {
            start: string
            end: string
        }
    }
    securitySettings?: {
        isLocked: boolean
    }
    history: History
}>

export type CreateProductGroup = Readonly<
    StrictOmit<ProductGroup, "id" | "productGroupCode" | "priceLists" | "history"> & {
        productGroupCode?: {
            id: number | null
        }
        priceLists?: { id: number }[]
    }
>

export type UpdateProductGroupState = {
    productGroupId: number | undefined
}

export type ProductGroupFormValues = Readonly<{
    name: string
    isActive?: boolean
    availableTime: boolean
    weekDays: WeekDaysType[]
    timeIntervalStart: DateTime
    timeIntervalEnd: DateTime
    productGroupCode?: ProductGroupCode
    priceList: PriceListType | null
    // priceLists: PriceListType[]
    isLocked: boolean
}>
